import { render, staticRenderFns } from "./partyDetail.vue?vue&type=template&id=6ca21874&scoped=true"
import script from "./partyDetail.vue?vue&type=script&lang=js"
export * from "./partyDetail.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/articleDetail.css?vue&type=style&index=0&id=6ca21874&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca21874",
  null
  
)

export default component.exports